export const OfferApplicantValue = {
    "group": "apply",
    "subGroup": {
        "information": "information"
    },
    "field": {
        "fullName": "fullName",
        "emailAddress": "emailAddress",
        "phoneNumber": "phoneNumber",
        "coverLetter": "coverLetter",
        "professionalExperience": "professionalExperience", // [{company: company, period: period, description: description}]
        "skill": "skill", // [{skill: skill}]
        "education": "education", // [{university: university, period: period, description: description}]
        "offer": "offer",
        "status": "status",
        "assesment": "assesment",
        "answeredQuestions": "answeredQuestions", // [{question: question, answer: answer}]
        "isAnsweredAllQuestions": "isAnsweredAllQuestions",
        "answeredTechnicalQuestions": "answeredTechnicalQuestions",
        "isAnsweredAllTechnicalQuestions": "isAnsweredAllTechnicalQuestions",
        "language": "language",
        "availability": "availability",
        "expectedSalary": "expectedSalary",
        "submittedLanguage": "submittedLanguage",
        "otp": "otp",
        "recruiterEmail": "recruiterEmail"
    }
}